export default "__VITE_ASSET__HrfzqBKP__"